function IsEmail(email) {
  var regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
}

let introData = document.querySelector(".address-fild");
let step1 = document.querySelector("#step-1");
let step2 = document.querySelector("#step-2");
let step2Panel = step2.querySelector(".panel-heading");
let step3 = document.querySelector("#step-3");
let step3Panel = step3.querySelector(".panel-heading");
let step3Tab = step3.querySelector(".pannel-tab");
let step4 = document.querySelector("#step-4");

//Change Address
let addressButton = document.querySelector('[name="saveAddress"]');
let addressInput = document.querySelector("#alternateAddress");
addressButton.addEventListener("click", function (event) {
  if (addressInput.value != "") {
    document.querySelector('[name="clientAddress"]').innerHTML =
      addressInput.value;
    document.querySelector('[name="address"]').value = addressInput.value;
    document.querySelector(".address-popup").classList.remove("open");
    document.querySelector(".overlay-wrap").classList.remove("open");
  }
});

// Confirm Address Btn
let confirmButton = document.querySelector(".ct-btn");
let confirmSvg = document.querySelector(".address_confirm-svg");
confirmButton.addEventListener("click", function (event) {
  confirmSvg.style.display = "block";
  step2Panel.click();
  step3Panel.click();
  step3Tab.classList.remove("disabled");
});

// Qty Selector
step3.addEventListener("click", function (e) {
  if (e.target && e.target.matches("span.plus")) {
    var val = e.target.previousElementSibling.value;
    var maxval = e.target.previousElementSibling.getAttribute("max");
    if (val < maxval) {
      val++;
      e.target.previousElementSibling.value = val;
    }
  }
  if (e.target && e.target.matches("span.minus")) {
    var val = e.target.nextElementSibling.value;
    var maxval = e.target.nextElementSibling.getAttribute("max");
    var minval = e.target.nextElementSibling.getAttribute("min");
    if (val > minval) {
      val--;
      e.target.nextElementSibling.value = val;
    }
  }
});

let input_val_waist = false;
let input_val_length = false;

step3.addEventListener("click", function (e) {
  if (e.target) {
    function alterValue(element, increment) {
      var val = parseFloat(element.value);
      var maxval = parseInt(element.getAttribute("max"));
      var minval = parseInt(element.getAttribute("min"));

      if (increment && val < maxval) {
        val += 0.5;
      } else if (!increment && val > minval) {
        val -= 0.5;
      }

      element.value = val;
      return val;
    }

    // Waist adjustment
    if (e.target.matches("span.alterPlusWaist")) {
      input_val_waist = alterValue(e.target.previousElementSibling, true) > 2;
    } else if (e.target.matches("span.alterMinusWaist")) {
      input_val_waist = alterValue(e.target.nextElementSibling, false) > 2;
    }

    // Length adjustment
    if (e.target.matches("span.alterPlusLength")) {
      input_val_length = alterValue(e.target.previousElementSibling, true) > 2;
    } else if (e.target.matches("span.alterMinusLength")) {
      input_val_length = alterValue(e.target.nextElementSibling, false) > 2;
    }

    // Major alteration container display logic
    if (input_val_length || input_val_waist) {
      document.querySelector(".major_alteration_container").style.display =
        "block";
      document.querySelector(".request-btn").disabled = true;

      const major_alt_accepted = document.getElementById("major_alt_accepted");
      major_alt_accepted.addEventListener("change", function () {
        document.querySelector(".request-btn").disabled = !this.checked;
        console.log(
          "Checkbox is " + (this.checked ? "checked" : "unchecked") + ".."
        );
      });
    } else {
      const majorAlterationContainer = document.querySelector(
        ".major_alteration_container"
      );
      document.getElementById("major_alt_accepted").checked = false;

      if (majorAlterationContainer) {
        majorAlterationContainer.style.display = "none";
      }
      document.querySelector(".request-btn").disabled = false;
    }
  }
});

// select Pants
let orderDiv = document.querySelector("#orderData");
let selectItemNumber = document.querySelector('[name="itemSelected"]').value;
orderDiv.addEventListener("click", function (e) {
  if (e.target && e.target.matches("li.pantItem")) {
    selectItemNumber++;
    document.querySelector(".alteration-popup").classList.remove("open");
    document.querySelector(".overlay-wrap").classList.remove("open");
    document.querySelector('[name="itemSelected"]').value = selectItemNumber;
    generatePants(e.target.id);
    document.querySelector("#" + e.target.id).classList.add("disabled");
  }
});

function generatePants(value) {
  var selectItemNumberIndex = selectItemNumber - 1;
  let id = value.split("_");
  let lineItem_id = document.querySelector(
    '[name="orderLineItemId_' + id[1] + '"]'
  ).value;
  let title = document.querySelector(
    '[name="orderLineItemsTitle_' + id[1] + '"]'
  ).value;
  let qty = document.querySelector(
    '[name="orderLineItemsQty_' + id[1] + '"]'
  ).value;
  let image = document.querySelector(
    '[name="orderLineItemsImage_' + id[1] + '"]'
  ).value;
  if (qty == 1) {
    var qtyPanel = ``;
  } else {
    var qtyPanel = `
    <div class="quantity-bottom">
      <div class="left">
        <p>How many of the <b> ${qty} pants </b> do you want to alter?</p>
      </div>
      <div class="right">
        <span class="minus">-</span>
        <input type="number" class="" max="${qty}" min="0" pattern="[0-9]*" name="alteration_items[${selectItemNumberIndex}]quantity" value="1" readonly>
        <span class="plus">+</span>
      </div>
    </div>`;
  }

  let data = `
  <div class="repeater-block" id="repeaterBlock_${selectItemNumberIndex}">
    <div class="alteration-quantity">
      <div class="quantity-top">
        <div class="left">
          <figure>
            <img src="${image}">
          </figure>
        </div>
        <div class="right selectItemQty">
          <p>${title}</p>
          <span>
            Qty - ${qty}
          </span>
        </div>
      </div>
  
      ${qtyPanel}
    </div>
  
    <div class="waist-alteration waistAlteration">
      <div class="quantity-bottom">
        <div class="left">
          <p>How much waist you want to alter?</p>
        </div>
        <div class="right inputBox">
          <span class="alterMinus alterMinusWaist">-</span>
          <input type="number" class="alterInput" min="-4" max="4" pattern="[0-9]*" name="alteration_items[${selectItemNumberIndex}]waist" value="0" readonly>
          <span class="alterPlus alterPlusWaist">+</span>
        </div>
      </div>
    </div>
    <div class="waist-alteration lengthAlteration">
      <div class="quantity-bottom">
        <div class="left">
          <p>How much length you want to alter?</p>
        </div>
        <div class="right inputBox">
          <span class="alterMinus alterMinusLength">-</span>
          <input type="number" class="lengthInput" min="-4" max="4" pattern="[0-9]*" name="alteration_items[${selectItemNumberIndex}]length" value="0" readonly>
          <span class="alterPlus alterPlusLength">+</span>
        </div>
      </div>
    </div>
    <div class="major_alteration_container" style='display: none;'>
      <div class="major_alteration_popup">
        <span class="info_svg">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
            <path d="M17.8307 13.7487C17.8307 9.42247 14.3236 5.91537 9.9974 5.91537C5.67116 5.91537 2.16406 9.42247 2.16406 13.7487C2.16406 18.0749 5.67116 21.582 9.9974 21.582C14.3236 21.582 17.8307 18.0749 17.8307 13.7487Z" fill="white" stroke="#BC9714" />
            <path d="M10 17.082V13.7487" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 10.418H10.0067" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <p>
          You are requesting a major alteration. In order to carry out this alteration,
          we will need your sample pants to ensure that we get your fitting correct.
        </p>
      </div>
      <div class="checkbox_container">
        <input type="checkbox" id="major_alt_accepted" value="">
        <label for="major_alt_accepted"></label>
        <span>I confirm I will send my sample pants.</span>
      </div>
    </div>
    <!-- <div class="waist-alteration waistAlteration">
        <div class="radio-btn">
          <input type="radio" value="1" name="alteration_items[${selectItemNumberIndex}]waist">
          <span>Waist Increase</span>
        </div>
        <div class="radio-btn">
          <input type="radio" value="-1" name="alteration_items[${selectItemNumberIndex}]waist">
          <span>Waist Decrease</span>
        </div>
      </div>
      <div class="waist-alteration lengthAlteration">
        <div class="radio-btn">
          <input type="radio" value="1" name="alteration_items[${selectItemNumberIndex}]length">
          <span>Length Increase</span>
        </div>
        <div class="radio-btn">
          <input type="radio" id="length" value="-1" name="alteration_items[${selectItemNumberIndex}]length">
          <span>Length Decrease</span>
        </div>
      </div> -->
  
    <!--<div class="waist-alteration otherAlteration">
      <div class="radio-btn">
        <input type="radio" value="other" name="alteration_items[${selectItemNumberIndex}]overall_fit">
        <span>Other</span>
      </div>
    </div>-->
    <div class="additional-area">
      <textarea name="alteration_items[${selectItemNumberIndex}]note" placeholder="Any additional comments for the alterations team."></textarea>
    </div>
    <div class="upload-image">
      <h3>Uploading images is mandatory as it helps us to understand the key issue with your fit. It allows us to assist you better and get your fit right.</h3>
      <p>Please upload a min of 3 images - front full, side, and back view.</p>
      <div class="item">
        <div class="file-upload">
  
          <div class="image-upload-wrap">
  
            <div class="upload__box">
              <span class="add-icon">
                + Upload images
              </span>
              <div class="upload__btn-box">
                <label class="upload__btn">
                  <div class="fileInputArea">
                    <input type="file" name="alteration_items[${selectItemNumberIndex}]alteration_images[0]media" data-id="${selectItemNumberIndex}" data-fileindex="0" data-max_length="20" class="upload__inputfile" accept="image/*">
                  </div>
                </label>
              </div>
              <div class="upload__img-wrap"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <input type="hidden" name="alteration_items[${selectItemNumberIndex}]order_item_id" value="${lineItem_id}" />
  </div>`;
  document
    .querySelector("#selectedPants")
    .insertAdjacentHTML("beforeend", data);
  document.querySelector(".add-btn").style.display = "none";
  if (
    document.querySelector('[name="totalPants"]').value >
    document.querySelector('[name="itemSelected"]').value
  ) {
    document.querySelector(".add-more").style.display = "block";
  } else {
    document.querySelector(".add-more").style.display = "none";
  }
  document.querySelector(".request-btn").style.display = "block";
  $("html, body").animate(
    {
      scrollTop:
        $("#repeaterBlock_" + selectItemNumberIndex).offset().top - 120,
    },
    600
  );
}

// step 1
let orderValidateButton = document.querySelector('[name="orderValidate"]');
orderValidateButton.addEventListener("click", async function (event) {
  event.preventDefault();

  let orderId = document.querySelector('[name="orderId"]').value;
  let phoneNumber = document.querySelector(
    '[name="customerPhoneNumber"]'
  ).value;

  if (!IsEmail(phoneNumber)) {
    alert("Please enter a valid Email id");
    document.querySelector('[name="customerPhoneNumber"]').focus();
    return;
  }

  if (!orderId || isNaN(orderId)) {
    alert("Must input numbers");
    document.querySelector('[name="orderId"]').focus();
    return;
  }

  document.querySelector("#loadingDiv1").style.display = "block";

  phoneNumber = encodeURIComponent(phoneNumber);

  try {
    const response = await fetch(
      `https://alterations-e27d5c1f.serverless.boltic.app/api/alterations/order-lookup?order=${orderId}&customer=${phoneNumber}`,
      {headers: {"X-API-Key": "pk_live_b3aae8e72cc0d931840ee593","X-API-Secret": "psk_zBz54eQ7pgF7MvEO4F0n6myyMs4Nz5r_","X-Company-Id": "9258"}}
    );
    const data = await response.json();

    if (data.line_items.length) {
      updatePageWithOrderData(data);
    }
  } catch (err) {
    console.log("Failed to fetch page: ", err);
  } finally {
    document.querySelector("#loadingDiv1").style.display = "none";
  }
});

function updatePageWithOrderData(data) {
  document.querySelector(".clientName").innerHTML = data.customer_name;
  document.querySelector(".orderName").innerHTML = data.order_name;
  document.querySelector('[name="clientAddress"]').innerHTML = formatAddress(
    data.shipping_address
  );
  document.querySelector('[name="address"]').value = formatAddress(
    data.shipping_address
  );
  document.querySelector('[name="email"]').value = data.customer_email;
  document.querySelector('[name="phone"]').value = formatPhoneNumber(
    data.customer_phone
  );
  document.querySelector('[name="order_id"]').value = data.order_number;
  document.querySelector('[name="totalPants"]').value = data.line_items.length;

  displayOrderItems(data.line_items);

  step1.style.display = "none";
  introData.style.display = "block";
  step2.style.display = "block";
  step3.style.display = "block";

  document
    .querySelector('[name="submitForAlteration"]')
    .addEventListener("click", handleAlterationSubmit);
}

function formatAddress(address) {
  return address.address2
    ? `${address.address1}, ${address.address2}, ${address.city}, ${address.zip}, ${address.province} ${address.province_code}, ${address.country}, ${address.phone}`
    : `${address.address1}, ${address.city}, ${address.zip}, ${address.province} ${address.province_code}, ${address.country}, ${address.phone}`;
}

function formatPhoneNumber(phone) {
  return phone ? phone.replace(" ", "").replace(/^0+/, "") : "";
}

function displayOrderItems(items) {
  const result = items
    .map((item, index) => {
      const templateReadyMade = item.properties.find(
        (property) => property.name == "template"
      );
      return `
            <ul>
                <li class="pantItem" id="selectitem_${index}" style="display: ${templateReadyMade?.value === "ready-made" ? "none" : "flex"}">
                    <input type="hidden" name="orderLineItemId_${index}" value="${item.id}" />
                    <input type="hidden" name="orderLineItemsTitle_${index}" value="${item.title}" />
                    <input type="hidden" name="orderLineItemsQty_${index}" value="${item.quantity}" />
                    <input type="hidden" name="orderLineItemsImage_${index}" value="${item.image}" />
                    <div class="left-column">
                        <figure><img src="${item.image}"></figure>
                    </div>
                    <div class="right-column selectItemQty">
                        <p>${item.title}</p>
                        <span>Qty - ${item.quantity}</span>
                    </div>
                </li>
            </ul>`;
    })
    .join("");

  document.querySelector("#orderData").innerHTML = result;
}

async function handleAlterationSubmit(event) {
  event.preventDefault();
  let orderAlterationButton = event.target;
  orderAlterationButton.disabled = true;
  document.querySelector(".loader-wrap1").classList.add("show");

  let form = document.getElementById("alteration_form");
  let formData = new FormData(form);

  formData.forEach((value, key) => {
    if (value instanceof File && !value.name.trim()) {
      formData.delete(key);
    }
  });

  // Check if there are any files uploaded
  let hasFiles = false;
  formData.forEach((value, key) => {
    if (value instanceof File && value.name.trim()) {
      hasFiles = true;
    }
  });

  // Show alert if no files are uploaded
  if (!hasFiles) {
    alert("Please upload at least one image before submitting.");
    orderAlterationButton.disabled = false;
    document.querySelector(".loader-wrap1").classList.remove("show");
    return;
  }

  // console.log(Object.fromEntries(formData));

  try {
    // const response = await fetch(
    //   "https://oms-api.pantproject.com/api/alterations/",
    //   {
    //     method: "POST",
    //     body: formData,
    //     headers: {
    //       Accept: "application/json"
    //     },
    //   }
    // );

    const response = await fetch(
      "https://alterations-e27d5c1f.serverless.boltic.app/api/alterations/",
      {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          "X-API-Key": "pk_live_0c5be1762e4d245ed1becd2e",
          "X-API-Secret": "psk_KyzBM0geY9xDLnb4tA5fNzZJ-Pk_66vr",
          "X-Company-Id": "9258"
        },
      }
    );
    const data = await response.json();
    displayAlterationResults(data.alteration_items);
  } catch (error) {
    console.error("Error: ", error);
  }
}

function displayAlterationResults(items) {
  const result_data = items
    .map((item) => {
      let waist = item.waist ? `Waist alter by ${item.waist} and ` : "";
      let length = item.length ? `Length alter by ${item.length}` : "";
      let other = item.overall_fit === "other" ? ", Other" : "";

      let alteration_image = item.alteration_images
        .map((image) => {
          return image.media
            ? `<div><figure><img src="${image.media}"/></figure></div>`
            : "";
        })
        .join("");

      return `
        <div class="submit-wrap">
            <div class="pannel-tab">
                <div class="panel-heading open">Alterations</div>
                <div class="panel-content" style="display:block;">
                    <ul>
                        <li>
                            <h4>${item.order_item.title} x ${item.order_item.quantity}</h4>
                            <p>${waist}${length}${other}</p>
                            <div class="image-wrap">${alteration_image}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>`;
    })
    .join("");

  document
    .getElementById("alteration_form")
    .insertAdjacentHTML("afterend", result_data);
  document.querySelector("html, body").animate(
    {
      scrollTop: $("#alteration_form").offset().top - 100,
    },
    600
  );
  document.getElementById("step-2").style.display = "none";
  document.getElementById("alteration_form").remove();
  document.querySelector(".request-btn").remove();
  document.querySelector(".sucess-msg").style.display = "block";
  introData.querySelector("h2").remove();
  introData.querySelector("p").remove();
  var newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    "/pages/alteration-requested";
  window.history.pushState({ path: newurl }, "", newurl);
}

document.addEventListener("DOMContentLoaded", function () {
  const imgArray = [];

  // Handle file input change event (delegated)
  document.addEventListener("change", function (e) {
    if (!e.target.matches(".upload__inputfile")) return;

    const inputFile = e.target;
    const mainDivBlockPant = inputFile.closest(".repeater-block");
    const mainDivBlockPantId = mainDivBlockPant.getAttribute("id");
    const imgWrap = inputFile.closest(".upload__box").querySelector(".upload__img-wrap");
    let maxLength = parseInt(inputFile.dataset.max_length, 10);
    const pantId = inputFile.dataset.id;
    const fileInputArea = mainDivBlockPant.querySelector(".fileInputArea");

    // Count hidden file inputs inside the file input area
    let fileIndex = Array.from(fileInputArea.querySelectorAll("input.upload__inputfile")).filter(function (el) {
      return window.getComputedStyle(el).display === "none";
    }).length;

    const files = Array.from(inputFile.files);

    files.forEach(function (f) {
      if (!f.type.match("image.*") || imgArray.length >= maxLength) {
        return;
      }
      if (imgArray.filter(img => img !== undefined).length >= maxLength) {
        return;
      }

      fileIndex++;
      maxLength--;

      const newFileInputHTML = `<input type="file" name="alteration_items[${pantId}]alteration_images[${fileIndex}]media" data-id="${pantId}" data-fileindex="${fileIndex}" data-max_length="${maxLength}" class="upload__inputfile" accept="image/*">`;
      
      // Hide all current file inputs with the class "upload__inputfile"
      document.querySelectorAll(".upload__inputfile").forEach(function (el) {
        el.style.display = "none";
      });
      
      // Append the new file input to the file input area
      fileInputArea.insertAdjacentHTML("beforeend", newFileInputHTML);
      
      imgArray.push(f);

      const reader = new FileReader();
      reader.onload = function (event) {
        // Use the current count of .upload__img-close elements as data-number
        const imageCount = document.querySelectorAll(".upload__img-close").length;
        const html = `
          <div class='upload__img-box'>
            <div style='background-image: url(${event.target.result})' data-number='${imageCount}' data-file='${f.name}' class='img-bg'>
              <div class='upload__img-close'></div>
            </div>
          </div>`;
        imgWrap.insertAdjacentHTML("beforeend", html);
      };
      reader.readAsDataURL(f);
    });
  });

  // Handle click on image close button (delegated)
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".upload__img-close");
    if (!closeBtn) return;

    const parentDiv = closeBtn.parentElement;
    const fileName = parentDiv.dataset.file;
    // Find the currently visible file input (if any)
    const visibleInput = Array.from(document.querySelectorAll(".upload__inputfile")).find(function (input) {
      return input.offsetParent !== null;
    });
    const currentPantId = visibleInput ? visibleInput.dataset.id : null;
    const currentFileIndex = parentDiv.dataset.number;

    // Remove the file from imgArray and show its corresponding input
    for (let i = 0; i < imgArray.length; i++) {
      if (imgArray[i].name === fileName) {
        const selector = `input[name="alteration_items[${currentPantId}]alteration_images[${currentFileIndex}]media"]`;
        const targetInput = document.querySelector(selector);
        if (targetInput) {
          targetInput.style.display = "";
        }
        imgArray.splice(i, 1);
        break;
      }
    }
    const imgBox = closeBtn.closest(".upload__img-box");
    if (imgBox) {
      imgBox.parentNode.removeChild(imgBox);
    }
  });

  // Function to toggle popup visibility
  const togglePopup = function (selector, show) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (show) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    });
    document.querySelectorAll(".overlay-wrap").forEach(function (el) {
      if (show) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    });
  };

  // Open the alteration popup when clicking on add-btn or add-more
  document.querySelectorAll(".add-btn, .add-more").forEach(function (el) {
    el.addEventListener("click", function () {
      togglePopup(".alteration-popup", true);
    });
  });

  // Close the alteration popup and remove "open" from address-popup on overlay click
  document.querySelectorAll(".overlay-wrap").forEach(function (el) {
    el.addEventListener("click", function () {
      togglePopup(".alteration-popup", false);
      document.querySelectorAll(".address-popup").forEach(function (popup) {
        popup.classList.remove("open");
      });
    });
  });

  // When clicking the edit button, hide address_confirm-svg and open the address popup
  document.querySelectorAll(".edit").forEach(function (el) {
    el.addEventListener("click", function () {
      document.querySelectorAll(".address_confirm-svg").forEach(function (svgEl) {
        svgEl.style.display = "none";
      });
      togglePopup(".address-popup", true);
    });
  });
});
